// istanbul ignore file
enum TrackingActionCategory {
    DocumentUpload = 'document_upload',
    AccessIssuesWizard = 'access_issues_wizard',
    ReportedFindingsWizard = 'reported_findings_wizard',
    App = 'app'
}

enum TrackingAction {
    DropzoneClick = 'dropzone_click',
    DropzoneUploading = 'dropzone_uploading',
    DropzoneUploadResult = 'dropzone_upload_result',

    AccessIssuesWizardBannerClicked = 'access_issues_wizard_banner_clicked',
    AccessIssuesWizardOpened = 'access_issues_wizard_opened',
    AccessIssuesWizardClosed = 'access_issues_wizard_closed',
    AccessIssuesWizardFatalError = 'access_issues_wizard_fatal_error',
    AccessIssuesWizardResolutionStarted = 'access_issues_wizard_resolution_started',
    AccessIssuesWizardExtraResolutionStarted = 'access_issues_wizard_extra_resolution_started',
    AccessIssuesWizardEntryMethodUnblocked = 'access_issues_wizard_entry_method_unblocked',
    AccessIssuesWizardExtraEntryMethodUnblocked = 'access_issues_wizard_extra_entry_method_unblocked',
    AccessIssuesWizardSolutionPerformed = 'access_issues_wizard_solution_performed',
    AccessIssuesWizardExtraSolutionPerformed = 'access_issues_wizard_extra_solution_performed',
    AccessIssuesWizardNoAccessIssues = 'access_issues_wizard_no_access_issues',
    AccessIssuesWizardAllEntryMethodsDisqualified = 'access_issues_wizard_all_entry_methods_disqualified',
    AccessIssuesWizardNoSolutions = 'access_issues_wizard_no_solutions',
    AccessIssuesWizardAccessIssuePresented = 'access_issues_wizard_access_issue_presented',

    ReportedFindingsWizardOpened = 'reported_findings_wizard_opened',
    ReportedFindingsWizardClosed = 'reported_findings_wizard_closed',
    ReportedFindingsWizardFatalError = 'reported_findings_wizard_fatal_error',

    ReportedFindingsWizardResolveByThirdPartyStarted = 'reported_findings_wizard_resolve_by_third_party_started',
    ReportedFindingsWizardResolveByThirdPartySelectionContinue = 'reported_findings_wizard_resolve_by_third_party_selection_continue',
    ReportedFindingsWizardResolveByThirdPartyDisclaimer = 'reported_findings_wizard_resolve_by_third_party_third_party_disclaimer',
    ReportedFindingsWizardViewQuote = 'reported_findings_wizard_view_quote',
    ReportedFindingsWizardForwardQuote = 'reported_findings_wizard_forward_quote',
    ReportedFindingsWizardRequestQuote = 'reported_findings_wizard_request_quote',
    ReportedFindingsWizardNoReportedFindings = 'reported_findings_wizard_no_reported_findings',
    ReportedFindingsWizardDismissed = 'reported_findings_wizard_dismissed',
    ReportedFindingsWizardUndismissed = 'reported_findings_wizard_undismissed',
    ReportedFindingsWizardBuildYearStarted = 'reported_findings_wizard_build_year_started',
    ReportedFindingsWizardInformDiStarted = 'reported_findings_wizard_inform_di_started',
    ReportedFindingsWizardBuildSubmitted = 'reported_findings_wizard_build_submitted',

    PageNotFound = 'page_not_found'
}

export { TrackingActionCategory, TrackingAction };
